"use strict";
/**
 * Namespace for touch events
 * @namespace pfKioskTouch
 */
var pfKioskTouch = {

    init: function() {
        var scrollPanel = $('#timeline-scroller');
        if (scrollPanel && scrollPanel.length === 1) {
            scrollPanel[0].addEventListener('touchend', pfKioskTouch.process_touchend, false);
        };
    },

    process_touchend: function(ev) {
        pfKiosk.scrollTimeout();
    },
};

if ( typeof module === 'object' && module.exports) {
    module.exports = pfKioskTouch;
}